import { defaultHttpClient } from '../../httpClient';
import type { PostRetailAdDisplayEventRequest } from './types';

export const postRetailAdDisplayEvent = (executableId: number) => {
  return defaultHttpClient.request<void>({
    method: 'POST',
    url: '/api/v2/retail_ad/display-event/',
    data: { executable_id: executableId } satisfies PostRetailAdDisplayEventRequest,
  });
};
